import { useEffect, useId, useRef, useState } from "react";
import { FiEdit2, FiMoreVertical, FiTrash2 } from "react-icons/fi";

export default function ModuleActions({ title, disabled, onEdit, onDelete, kind = "Folder", editLabel = "Edit" }) {
  const [open, setOpen] = useState(false);
  const root = useRef(null), trigger = useRef(null), item = useRef(null);
  const id = useId();
  useEffect(() => {
    if (!open) return;
    item.current?.focus();
    const outside = event => { if (!root.current?.contains(event.target)) setOpen(false); };
    document.addEventListener("pointerdown", outside);
    return () => document.removeEventListener("pointerdown", outside);
  }, [open]);
  return <div ref={root} className="relative shrink-0" onBlur={event => {
    if (!event.currentTarget.contains(event.relatedTarget)) setOpen(false);
  }} onKeyDown={event => {
    if (event.key === "Escape") { event.stopPropagation(); setOpen(false); trigger.current?.focus(); }
    if (open && ["ArrowDown", "ArrowUp", "Home", "End"].includes(event.key)) {
      event.preventDefault();
      const items = [...root.current.querySelectorAll('[role="menuitem"]')];
      const current = items.indexOf(document.activeElement);
      const next = event.key === "Home" ? 0 : event.key === "End" ? items.length - 1 : (current + (event.key === "ArrowUp" ? -1 : 1) + items.length) % items.length;
      items[next]?.focus();
    }
  }}>
    <button ref={trigger} type="button" disabled={disabled} aria-label={`Options for ${title}`} title={`${kind} options`} aria-haspopup="menu" aria-expanded={open} aria-controls={open ? id : undefined}
      onClick={() => setOpen(value => !value)} onKeyDown={event => { if (event.key === "ArrowDown") { event.preventDefault(); setOpen(true); } }}
      className="flex h-9 w-9 items-center justify-center rounded-md text-gray-600 hover:bg-gray-100 disabled:opacity-50"><FiMoreVertical /></button>
    {open && <div id={id} role="menu" aria-label={`${title} options`} className="absolute right-0 top-full z-20 mt-1 w-36 rounded-md border border-gray-100 bg-white p-1 shadow-lg">
      <button ref={item} type="button" role="menuitem" onClick={() => { setOpen(false); onEdit(); }} className="flex w-full items-center gap-2 rounded px-3 py-2 text-left text-sm font-medium text-gray-800 hover:bg-orange-50 focus:bg-orange-50 focus:outline-none"><FiEdit2 aria-hidden="true" />{editLabel}</button>
      {onDelete && <button type="button" role="menuitem" onClick={() => { setOpen(false); onDelete(); }} className="flex w-full items-center gap-2 rounded px-3 py-2 text-left text-sm font-medium text-red-700 hover:bg-red-50 focus:bg-red-50 focus:outline-none"><FiTrash2 aria-hidden="true" />Delete</button>}
    </div>}
  </div>;
}
